/** Debug overlay: draws a red X at the computed fist position each frame when fistMarker flag is on. */
import Phaser from 'phaser';
import { Component } from './Component';
import { DebugConfig } from '../debug/DebugConfig';
import { getFistPosition } from '../utils/PlayerGeometry';
import type { Position } from '../utils/Types';

const CROSS_SIZE = 3;
const CROSS_COLOR = 0xff0000;
const CROSS_ALPHA = 1;
const CROSS_LINE_WIDTH = 1;

/** Renders a red cross at the fist world position every frame when the fistMarker debug flag is enabled. */
export class FistDebugComponent implements Component {
  private sprite: Phaser.GameObjects.Sprite;
  private facing: Position;
  private graphics: Phaser.GameObjects.Graphics;

  constructor(scene: Phaser.Scene, sprite: Phaser.GameObjects.Sprite, facing: Position) {
    this.sprite = sprite;
    this.facing = facing;
    this.graphics = scene.add.graphics();
  }

  update(_delta: number): void {
    this.graphics.clear();

    if (!DebugConfig.enabled || !DebugConfig.flags.fistMarker) return;

    const { x, y } = getFistPosition(this.sprite.x, this.sprite.y, this.facing);

    this.graphics.setDepth(9999);
    this.graphics.lineStyle(CROSS_LINE_WIDTH, CROSS_COLOR, CROSS_ALPHA);
    this.graphics.beginPath();
    this.graphics.moveTo(x - CROSS_SIZE, y - CROSS_SIZE);
    this.graphics.lineTo(x + CROSS_SIZE, y + CROSS_SIZE);
    this.graphics.moveTo(x + CROSS_SIZE, y - CROSS_SIZE);
    this.graphics.lineTo(x - CROSS_SIZE, y + CROSS_SIZE);
    this.graphics.strokePath();
  }

  destroy(): void {
    this.graphics.destroy();
  }
}
